import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    padding: "30px"
};

export const newPlanBtn = {
    textAlign: "right"
};

export const topRowTitles = {
    paddingTop: "20px"
};

export const topTitles = {
    background: Colors.primary,
    color: "white"
};

export const plansBox = {
    height: "500px",
    overlow: "auto",
    overflowX: "hidden",
    paddingTop: "20px"
};

export const singlePlan = {
    background: Colors.primary,
    color: "white",
    cursor: "pointer"
};
